<template>
    <div class="layout-advanced-search-box">
        <div class="layout-asb-title dsp-flex">
            <div class="layout-asb-item"><span>年柱</span></div>
            <div class="layout-asb-item"><span>月柱</span></div>
            <div class="layout-asb-item"><span>日柱</span></div>
            <div class="layout-asb-item"><span>时柱</span></div>
        </div>
        <div class="layout-asb-list dsp-flex">
            <div class="layout-asb-item" v-for="arr in searchChooseBoxList" :key="'box'+arr[0]['type']">
                <div class="layout-asb-box" v-for="data in arr" :key="data.type" @click="clickSearchItem(data)" >
                    <i v-if="!data.choosedData.text" class="iconfont icon-wenhao layout-asb-icon"></i>
                    <span v-else class="layout-asb-word" v-bind:class="'wd-' + data.choosedData.propXingEn">{{data.choosedData.text}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { DOM, SEARCH_DOM } from '../../modules/dom';
export default {
    name: 'AdvancedSearchBox',
    data() {
        return {
            itemSize: {width: 0, height: 0},
            basicPos: {x: 0, y: 0}  //第一个item的值，用来计算点击item的pos值，以确定三角形的定位
        }
    },
    computed: {
        searchChooseBoxList() {
            return this.$store.state.search.searchChooseBoxList;
        }
    },
    mounted: function() {        
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 10);
    },
    methods: {
        initDom() {
            var topDiv = document.getElementsByClassName('search-title-bar')[0];
            var titleDiv = document.getElementsByClassName('layout-asb-title')[0];
            var itemBoxDiv = document.getElementsByClassName('layout-asb-item')[0];
            var itemDiv = document.getElementsByClassName('layout-asb-box')[0];

            // 获取基础的定位值
            var x = parseInt(itemBoxDiv.clientWidth / 2) - 6 , y = topDiv.clientHeight + titleDiv.clientHeight + itemDiv.clientHeight + 20;
            this.$set(this.basicPos, 'x', x);
            this.$set(this.basicPos, 'y', y);
            this.$set(this.itemSize, 'width', itemBoxDiv.clientWidth);
            this.$set(this.itemSize, 'height', (itemDiv.clientHeight + 20));
            // console.log('AdvancedSearchBox-------mounted', this.basicPos, this.itemSize);
        },
        clickSearchItem(data) {
            this.$store.dispatch('search/updateSearchChooseData', data);
            this.$store.state.search.showChooseItemPop = true;
            var me = this;
            setTimeout(() => {
                DOM.updateChooseItemPopPos(data.pos, me.basicPos, me.itemSize);
            }, 0);
            setTimeout(() => {
                SEARCH_DOM.updateAdvancedSearchPageStyle();
            }, 20);
        }
    }
}
</script>